<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>热烈庆祝广东东进成功获得“企业信用评价AAA级信用企业”荣誉称号</h2>
        <img width="100%" :src="img[0]" alt="">
        <p>日前，我公司顺利通过评审，成功获得“企业信用评价AAA级信用企业”荣誉称号。这是国家权威信用评定的最高等级!</p>
        <p>
          企业信用评级是企业履行商业合约和社会责任能力的反映，也是企业日常经营状况健康度的权威表达。AAA级是企业信用最高等级，表示该企业经营的稳定性极强、风险性极低、信用指数高。它不仅成为企业与交易伙伴合作、赊销等决策的重要参考依据，更为优质企业获得更多的融资、投标、政策争取等商业“绿色通道"，它是企业信用价值的"身份证"，更是企业提升品牌价值与品牌竞争力宝贵的无形资产。良好的信用是企业立足生存之本，诚实守信，是赢得员工、客户及社会信赖的重要因素，亦是提升企业品牌形象、增强行业与社会影响力的重要法宝。以企业信用等级评“标准和评价指标体系为依据，采用信用监管和大数据监测手段，按照公正、独立的原则，对企业信用管理、经营状况、财务状况、发展前景等方面进行客观评估，并经协会信评办、信用评价专家委员会审核...通过这样繁多而面面俱到的评估手续，从侧面也反映出了这个证书的含金量。
        </p>
        <p>
          此次，公司获评“企业信用评价AAA级信用企业”，代表着我公司运营实力和企业信用度的综合提升，不仅是对我公司始终不忘初心，用心做事诚信经营的极大肯定，也为我公司更好的参与未来市场竞争，做强业务提供了更加有利的外部环境和条件。接下来，我公司将会坚持持久关注客需求，不断创新服务和技术，以个性化技术和服务方式，不断实现客户的个性化需求，用优质高效的让客户满意我们的服务，帮助客户成功!
        </p>
        <p>
          同期，广东东进获中小企业协会信用管理中心授牌，成为中国中小企业协会信用管理中心会员单位。东进负责人王先生表示，获得“AAA级信用企业”之誉，是对东进诚信经营最直接的肯定。这一殊荣的获得，也将进一步增强东进在行业中的品牌影响力及美誉度。后续，东进将毫不动摇地坚守这一原则，努力为员工、用户、社会创造更大的利益和价值。
        </p>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News1'})">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;热心公益献爱心，关怀...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"></span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px"></span>
        </el-col>
      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news5.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-family: 黑体, SimHei;
      font-size: 24px;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        margin: 20px 0;
        text-align: center;
        font-family: 黑体, SimHei;
        font-size: 24px;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>
